export const isLoading = (state) => state.opv.isLoading
export const isSuccess = (state) => state.opv.isSuccess
export const opvList = (state) => state.opv.opvList
export const selectedOpv = (state) => state.opv.selectedOpv
